import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filePreview',
})
export class FilePreviewPipe implements PipeTransform {
  transform(file: any, s3Url: string): { type: string, url: string, icon?: string } {
    const fullUrl = s3Url + file;
    const ext = (file || '').split('.').pop()?.toLowerCase();

    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext!)) {
      return { type: 'image', url: fullUrl };
    }

    if (ext === 'pdf') {
      return { type: 'pdf', url: fullUrl, icon: 'fa-file-pdf text-red-600' };
    }

    if (['doc', 'docx'].includes(ext!)) {
      return { type: 'word', url: fullUrl, icon: 'fa-file-word text-blue-600' };
    }

    if (['mp4', 'mov', 'avi', 'webm', 'mkv'].includes(ext!)) {
      return { type: 'video', url: fullUrl, icon: 'fa-file-video text-purple-600' };
    }

    if (['mp3', 'wav', 'ogg', 'm4a'].includes(ext!)) {
      return { type: 'audio', url: fullUrl, icon: 'fa-file-audio text-amber-600' };
    }

    if (['sql', 'csv', 'txt'].includes(ext!)) {
      return { type: 'download', url: fullUrl, icon: 'fa-database text-green-600' };
    }

    return { type: 'other', url: fullUrl, icon: 'fa-file text-gray-600' };
  }
}
